import React from "react";
import { createRoot } from "react-dom/client";  // Updated import for React 18
import App from "./App";
import { AuthProvider } from "./context/AuthContext";

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);  // Create the root using React 18 API
  root.render(
    <AuthProvider>
      <App />
    </AuthProvider>
  );
} else {
  console.error("Root container not found");
}
